
export default {
  data() {
    return {
      search: ""
    };
  },
  methods: {
    handleSearchInputChange() {
      this.$emit("search-item-changed", this.search);
    }
  }
};
